/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pure_Deft_Ape_RestInputs */

const en_pure_deft_ape_rest = /** @type {(inputs: Pure_Deft_Ape_RestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No imports found`)
};

const de_pure_deft_ape_rest = /** @type {(inputs: Pure_Deft_Ape_RestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Imports vorhanden`)
};

/**
* | output |
* | --- |
* | "No imports found" |
*
* @param {Pure_Deft_Ape_RestInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const pure_deft_ape_rest = /** @type {((inputs?: Pure_Deft_Ape_RestInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pure_Deft_Ape_RestInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pure_deft_ape_rest(inputs)
	return de_pure_deft_ape_rest(inputs)
});